/**
 * Task 30 (cut-over): shrunk to the three platform-level types. Institution-scoped access is now
 * granted entirely via roles/permission keys (see `services/role.service.ts`), never via this
 * enum — the legacy per-tenant values (InstitutionAdmin, InstitutionManager, StoreAdmin,
 * StoreManager, StoreStaff, Accountant, SalesRep) no longer exist anywhere in the system.
 */
export enum UserType {
    SystemAdmin = "SystemAdmin",
    SaaSOperator = "SaaSOperator",
    User = "User"
}
